
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-slate-700 border-t border-slate-600 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="relative w-8 h-8 bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg overflow-hidden shadow-md">
                {/* Chain-link fence pattern */}
                <svg
                  className="absolute inset-0 w-full h-full opacity-30"
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <defs>
                    <pattern
                      id="chainPatternFooter"
                      x="0"
                      y="0"
                      width="8"
                      height="8"
                      patternUnits="userSpaceOnUse"
                    >
                      <g fill="none" stroke="white" strokeWidth="0.5">
                        <path d="M0,4 L4,0 L8,4 L4,8 Z" />
                      </g>
                    </pattern>
                  </defs>
                  <rect width="100%" height="100%" fill="url(#chainPatternFooter)" />
                </svg>
                {/* Central "D" letter */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-white text-sm font-bold">D</span>
                </div>
                {/* Subtle glow effect */}
                <div className="absolute inset-0 bg-gradient-to-t from-transparent to-white/10"></div>
              </div>
              <Link to="/" className="text-2xl font-bold text-white tracking-tight hover:opacity-80 transition-opacity">SocialScoop.ai</Link>
            </div>
            <p className="text-slate-300 max-w-md">
              Creating digital boundaries for a healthier social media experience. 
              Filter the noise, amplify what matters.
            </p>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-slate-300 hover:text-white transition-colors">About</Link></li>
              <li><Link to="/privacy" className="text-slate-300 hover:text-white transition-colors">Privacy</Link></li>
              <li><Link to="/terms" className="text-slate-300 hover:text-white transition-colors">Terms</Link></li>
              <li><Link to="/security" className="text-slate-300 hover:text-white transition-colors">Security</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Connect</h3>
            <ul className="space-y-2">
              <li><a href="https://twitter.com/socialscoop" className="text-slate-300 hover:text-white transition-colors">Twitter</a></li>
              <li><a href="https://linkedin.com/company/socialscoop" className="text-slate-300 hover:text-white transition-colors">LinkedIn</a></li>
              <li><a href="mailto:info@socialscoop.ai" className="text-slate-300 hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>
        </div>
        
         <div className="border-t border-slate-600 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
           <div className="text-slate-400 text-sm">
             <p>© 2025 <Link to="/" className="hover:text-slate-300 transition-colors">SocialScoop.ai</Link>. All rights reserved.</p>
             <p className="mt-1">Digital Fencing™ is a trademark of SocialScoop.ai.</p>
           </div>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <div className="w-6 h-6 border border-slate-500 rotate-45"></div>
            <div className="w-4 h-4 border border-slate-500 rotate-12"></div>
            <div className="w-5 h-5 border border-slate-500 rotate-45"></div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
